import './OfficeCountryNavBar.css'

import React, { useEffect, useState } from 'react'

import greeceFlag from '../../../imgs/flags/greece.png'
import ukFlag from '../../../imgs/flags/uk.png'
import usaFlag from '../../../imgs/flags/usa.png'
import worldIcon from '../../../imgs/flags/worldwide.png'

export default function OfficeCountryNavBar({ warehouse, setWarehouse, anp }) {
  const [active, setActive] = useState('')

  useEffect(() => {
    setActive(`ocn-${warehouse}`)
  }, [warehouse])

  function clickHandler(elId, country) {
    setWarehouse(country)
    setActive(elId)
  }

  return (
    <div className='office-country-navbar-cont'>
      {!anp && (
        <div className={active == 'ocn-' ? 'ocn-item ocn-item-active' : 'ocn-item'} onClick={() => clickHandler('ocn-', '')} id='ocn-'>
          <img src={worldIcon} alt='World' style={{ height: '30px', margin: '3px' }} />
          <div className='ocn-item-title'>All</div>
        </div>
      )}
      {/* <div
        className={active == 'ocn-TR' ? 'ocn-item ocn-item-active' : 'ocn-item'}
        onClick={() => clickHandler('ocn-TR', 'TR')}
        id='ocn-TR'
      >
        <img src={turkeyFlag} alt="turkey" />
        <div className="ocn-item-title">Turkey</div>
      </div> */}
      <div
        className={active == 'ocn-GR' ? 'ocn-item ocn-item-active' : 'ocn-item'}
        onClick={() => clickHandler('ocn-GR', 'GR')}
        id='ocn-GR'
      >
        <img src={greeceFlag} alt='greece' />
        <div className='ocn-item-title'>Greece</div>
      </div>
      <div
        className={active == 'ocn-USA' ? 'ocn-item ocn-item-active' : 'ocn-item'}
        onClick={() => clickHandler('ocn-USA', 'USA')}
        id='ocn-USA'
      >
        <img src={usaFlag} alt='usa' />
        <div className='ocn-item-title'>USA</div>
      </div>
      <div
        className={active == 'ocn-UK' ? 'ocn-item ocn-item-active' : 'ocn-item'}
        onClick={() => clickHandler('ocn-UK', 'UK')}
        id='ocn-UK'
      >
        <img src={ukFlag} alt='uk' />
        <div className='ocn-item-title'>UK</div>
      </div>
    </div>
  )
}
